































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import AuthModule from '@/store/modules/Auth';
import ProfileModule from '@/store/modules/Profile';
import MarketingModule from '@/store/modules/Marketing';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';

@Component
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store)

  mainKey = 0;

  UserData: any = { ...CreateAccountData.initialUserData() };

  async created() {
    this.UserData.role = 'MEMBER';
    const expToken: any = jwt_decode(this.AuthInstance.token);
    this.UserData.source = this.AuthInstance.user.source;
    this.UserData.currency = expToken.currency ? expToken.currency : 'THB';
    this.UserData.isCrypto = expToken.isCrypto || false;
    this.UserData.isMechanic = expToken.isMechanic || false;
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
    });
    if (status.code) {
      this.checkError(status);
    } else {
      this.UserData.username = data.username;
      this.UserData.pt.general = this.AuthInstance.user.pt.general;
      this.UserData.type = this.AuthInstance.user.type;
    }
  }

  async onSubmit() {
    this.UserData.role = 'MEMBER';
    this.GeneralInstance.toggleLoading(true);
    const resSelf = await this.MarketingInstance.Fetch();
    this.UserData.isFeature = await resSelf[0].isFeature;
    const {
      status: {
        code, message,
      },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
        currency: this.UserData.currency,
        source: this.UserData.source,
      });
      this.UserData = { ...CreateAccountData.initialUserData() };
      this.mainKey += 1;
    }
    this.UserData = { ...CreateAccountData.initialUserData() };
    await this.ProfileInstance.GetBalance();
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }
}
